import { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';

export default function DashboardStat({ title, value, chartData }) {
  const [loadChart, setLoadChart] = useState(false);

  useEffect(() => {
    if (!chartData) {
      setLoadChart(false);
      return;
    }
    if (loadChart) return;

    const timer = setTimeout(() => setLoadChart(true), 300);
    return () => clearTimeout(timer);
  }, [chartData, loadChart]);

  return (
    <div className="dashboardStat">
      <div className="dashboardStat__chart">
        <div>
          {loadChart && chartData?.options && (
            <ReactApexChart
              options={chartData.options}
              series={chartData.series}
              type="donut"
              className="donut-chart"
            />
          )}
        </div>
        <div>
          <p className="body-18m">{title}</p>
          <p
            className="title-h1r"
            dangerouslySetInnerHTML={{ __html: value }}
          />
        </div>
      </div>
    </div>
  );
}
